import { useEffect } from 'react'
import { t } from '../i18n'

/* "<title> – Instapres", or the site title for Početna (null). */
export function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title ? t('meta.pageTitle', { title }) : t('meta.title')
  }, [title])
}
